<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-question.svg" can-back-flag="1"></Header>
    </header>

    <!--一覧-->
	  <div id="wrapper">
      <div class="content">

        <div class="tree-box">
          <div id="treeList1" class="tree"></div>
          
          <footer id="footer">
            <div class="footer-box">
              <div class="question-footer">
                <div class="box-l">
                  <p>※ランダムで出題されます</p>
                </div>
                <div class="box-r">
                  <p><span>{{ count }}</span>問 選択中</p>
                </div>
              </div>
              <div class="btn-box">
                <button type="button" class="btn btn-start" v-on:click='nextAction'><img src="static/images/common/btn/btn-start.svg" alt="スタート"></button>
              </div>
            </div>
          </footer>

        </div>
      </div>

      <!--エラーダイアログ-->
      <div id="errorModal" data-remodal-id="errorModal" class="remodal modal-result-box" data-remodal-options="hashTracking:false">
        <div class="modal-content">
          <div class="btn-close-box">
            <button data-remodal-action="close" type="button" class="btn btn-close"><img src="static/images/common/btn/btn-close.svg" alt="閉じる"></button>
          </div>
          <div class="text-box">
            <p class="ttl">問題を選択してください</p>
          </div>
        </div>
      </div>

    </div>
      
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  data: function () {
    return {
      selectedCount: 0
    }
  },
  mounted: function () {
      
      $("body").removeClass()
      $("body").addClass("page-low")
      $("body").addClass("cat-question")
      $("body").addClass("page-question-index")
      cmd.adjustStyle()

      let self = this

      //ツリー更新
      var callback = function(){
        $('#treeList1').jstree("destroy")
        self.createTree("treeList1", self.treeData)

        //再計算
        cmd.adjustStyle()
      }

      //ツリー用データ作成
      self.search(callback)
      
  },
  methods: {
    ...mapActions('QuestionModule', {
      'search': 'search',      
      'prevAction': 'prevAction',
      'nextAction': 'nextAction'
    }),
    
    //ツリー作成
    createTree(tgt, collection) {

      var self = this

      //jsTree初期化
      $('#' + tgt)
      .on("loaded.jstree", function (e, data) {
        var instance = $(this).jstree(true)
        //instance.open_all()
        instance.close_all()
      })
      .on('changed.jstree', function (e, data) {

          //選択数更新
          var cnt = 0;
          var selectedElms = $('#treeList1').jstree("get_selected", true);
          $.each(selectedElms, function(idx, row) {
            if (row.id.substr(0, 1) == "q") {
              var nodes = row.original.nodes;
              cnt += parseInt(nodes.length)
            }
          })
          self.count = cnt
          /*
          //親ノードの選択状態を子ノードに伝搬
          var instance = $(this).jstree(true)
          if (data.node.state.selected) {
            instance.open_all(data.node)
          } else {
            instance.close_all(data.node)
          }
          */

      })
      .jstree({
        "core" : {
          "animation" : 200,
          "themes" : { "stripes" : false, "variant" : "large", "icons": false },
          "multiple" : true,
          'data' : collection
        },   
        "checkbox": {
          'keep_selected_style' : false
            //three_state: false,
            //cascade: 'up+down'
        },
        "plugins" : [
          "wholerow", "checkbox",
        ]
      });

    }
    
  },
  computed: {
    count: {
      get () {
        return this.selectedCount
      },
      set (value) {
        this.selectedCount = value
      }
    },
    ...mapGetters('QuestionModule', {
      'treeData': 'treeData',
      
    })
  },
  components: {
    Header
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/QuestionList.vue